import { UIHeading4, UIText1, UIText2, Image } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import { IOfferRowProps } from '../../../types';
import { DeactivatedLabel, Price } from '../../commonComponents';
import { WalkWayMinutes } from '../../commonComponents/WalkWayMinutes';
import * as styles from './styles.css';

export const WideOfferRow = React.forwardRef<HTMLDivElement, IOfferRowProps>(
  ({ onClick, selectable, data, isActive, isViewed, testId }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          styles['item'],
          selectable && styles['selectable'],
          isActive && styles['active'],
          isViewed && styles['viewed'],
        )}
        onClick={onClick}
        data-testid={testId}
      >
        <div className={cn(styles['cell'], styles['main'])}>
          <div className={styles['photo']}>
            <Image
              src={data.previewPhoto || ''}
              width={128}
              height={78}
              display="block"
              alt=""
              preloader
              objectFit="cover"
            />
          </div>
          <div className={styles['main-info']} data-name="WideOfferMainInfo">
            <UIHeading4 color="primary_100">{data.title}</UIHeading4>
            {data.walkWayMinutes && <WalkWayMinutes>{data.walkWayMinutes}</WalkWayMinutes>}
            {data.isDeactivated && (
              <div className={styles['deactivated-label']}>
                <DeactivatedLabel />
              </div>
            )}
          </div>
        </div>
        <div className={styles['cell']}>
          <Price diff={data.prices.priceDiff} subprice={data.prices.priceSqm}>
            {data.prices.price}
          </Price>
        </div>
        <div className={cn(styles['cell'], styles['l'])}>
          <UIText1>{data.exposition}</UIText1>
        </div>
        <div className={styles['cell']}>
          <UIText1>{data.dateStart}</UIText1>
          <div className={styles['xs']}>
            <UIText2 color="gray60_100">{data.expositionFull}</UIText2>
          </div>
        </div>
        <div className={styles['cell']}>
          <UIText1>{data.dateEnd}</UIText1>
        </div>
      </div>
    );
  },
);

WideOfferRow.displayName = 'WideOfferRow';
